import { useContext, useEffect, useMemo, useState } from 'react'

import { SocketContext } from '../../../context/SocketContext'
import { SelectElement } from '../../../components/selectElement2'

import LoadingOverlay from '../../../components/LoadingOverlay'
import { serverApi } from '../../../api';
import { getUsuarioStorage } from '../../../helpers/getUsuarioStorage';

export const RolesPantallas = () => {

    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);

    const [isLoading, setIsLoading] = useState(false);
    const [roles, setRoles] = useState([]);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'eol',
        sortDir: 'asc',
        ubicacion: '',
        codigoUbicacion: '',
        uidRol: ''
    });

    // tabla
    const [data, setData] = useState([]);

    // const [searchInput, setSearchInput] = useState('');

    //Select roles
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/usuarios/select-roles`, { codigoEntidad });
                console.log(resp.data);

                const opciones = resp.data.data.map((item) => ({ value: item.uidRol, label: item.rol.toUpperCase() }))
                setRoles(opciones);


            } catch (error) {
                console.error("Error al obtener los usuarios", error);
            } finally {

            }
        };

        fetch();

    }, [])


    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            setData(lista);
        };

        socket.on('lista-roles-pantallas', handler);

        return () => {
            socket.off('lista-roles-pantallas', handler);
        };

    }, [socket]);

    useEffect(() => {
        const codigoEntidad = usuario.codigoEntidad
        // const codigoUbicacion = usuario.codigoUbicacion

        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;


                const resp = await serverApi.post(
                    `/usuarios/roles-pantallas`,
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );

                console.log(resp);


                setData(resp.data.data || []);
                // setTotal(resp.data.total || 0);

            } catch (error) {
                console.error("Error al obtener tipos de atención", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();


    }, [query, usuario.codigoEntidad, usuario.codigoUbicacion]);


    const handleChecked = async (seleccion) => {

        const codigoPantalla = seleccion.target.id;
        const checked = seleccion.target.checked;
        if (query.uidRol === "") return;

        try {

            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if (codigoEntidad === "") return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            console.log(query);

            await serverApi.post(
                `/usuarios/edita-rol-pantalla`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    codigoPantalla,
                    checked
                }
            );

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }

    }

    const handleSelectRol = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidRol: selected.value,
        }));
    };

    return (
        <>
            {isLoading && <LoadingOverlay />}

            <div className={`content ${isLoading ? 'opacity' : ''} m-5`}>

                <div className='row'>
                    <div className='form-group col-lg-4 col-12'>

                        <label> Roles </label>
                        <SelectElement
                            options={roles}
                            name={"uidRol"}
                            isMulti={false}
                            closeOnMenuSelect={true}
                            value={roles.find(u => u.value === query.uidRol)}
                            onChange={(selected) => handleSelectRol(selected)}
                            classname="form-control form-control-lg"
                            isClearable={false}
                        />
                    </div>

                    <div className='form-group col-lg-8 col-12 rounded shadow p-3'>


                        <div className='col-12 '>
                            <table className='table table-responsive table-striped max600' width={'100%'}  >
                                <thead>
                                    <tr>
                                        <th width={'5%'}></th>
                                        <th width={'95%'}>Pantallas</th>
                                    </tr>
                                </thead>
                                <tbody width={'100%'} >
                                    {data.map((item, i) => (

                                        <tr key={item.codigoPantalla}>
                                            <td width={'5%'}>

                                                <div className="form-check form-switch">
                                                    {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                                                    <input
                                                        className="form-check-input"
                                                        checked={item.checked}
                                                        type="checkbox"
                                                        id={`${item.codigoPantalla}`}
                                                        onChange={(seleccion) => handleChecked(seleccion)}



                                                    />

                                                    <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                                </div>


                                            </td>
                                            <td width={'95%'}>
                                                {item.pantalla.toUpperCase()
                                                } -
                                                {item.codigoPantalla}
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>



                    </div>


                </div>

            </div>
        </>


    )
}
